import {
  createContext,
  type PropsWithChildren,
  useContext,
  useMemo,
  useState
} from "react";

import { appelerApi, corpsJson, enregistrerSession, lireSession } from "../api/client";
import type { Session, TypeOrganisation } from "../api/types";

interface Inscription {
  email: string;
  mot_de_passe: string;
  nom_utilisateur: string;
  nom_organisation: string;
  type_organisation: TypeOrganisation;
}

interface ValeurSession {
  session: Session | null;
  connecter: (email: string, motDePasse: string) => Promise<void>;
  inscrire: (donnees: Inscription) => Promise<void>;
  deconnecter: () => void;
}

const ContexteSession = createContext<ValeurSession | null>(null);

export function FournisseurSession({ children }: PropsWithChildren) {
  const [session, definirSession] = useState<Session | null>(() => lireSession());

  const valeur = useMemo<ValeurSession>(
    () => ({
      session,
      connecter: async (email, motDePasse) => {
        const nouvelleSession = await appelerApi<Session>("/auth/connexion", {
          method: "POST",
          body: corpsJson({ email, mot_de_passe: motDePasse })
        });
        enregistrerSession(nouvelleSession);
        definirSession(nouvelleSession);
      },
      inscrire: async (donnees) => {
        const nouvelleSession = await appelerApi<Session>("/auth/inscription", {
          method: "POST",
          body: corpsJson(donnees)
        });
        enregistrerSession(nouvelleSession);
        definirSession(nouvelleSession);
      },
      deconnecter: () => {
        enregistrerSession(null);
        definirSession(null);
      }
    }),
    [session]
  );

  return <ContexteSession.Provider value={valeur}>{children}</ContexteSession.Provider>;
}

export function utiliserSession(): ValeurSession {
  const contexte = useContext(ContexteSession);
  if (!contexte) {
    throw new Error("utiliserSession doit être utilisé dans FournisseurSession");
  }
  return contexte;
}
